module.exports = __webpack_public_path__ + "static/dc-sao-paulo-2ee1e4ec4612513b6d311d840b7f39d4.jpg";